<template>
  <TxRendererScreenshotArea>
    <ImageTemplate/>
    <ImageTemplateTitle/>
  </TxRendererScreenshotArea>
</template>

<script>
import ImageTemplate from './ImageTemplate'
import ImageTemplateTitle from './ImageTemplateTitle'
import ImageTemplateModule from "../store-mixin";

export default {
  name: 'ImageTemplateProduct',
  mixins: [ImageTemplateModule()],
  components: {
    ImageTemplate,
    ImageTemplateTitle,
  },
}
</script>

<style scoped lang="scss">

</style>

